import { Modal } from "@rentiohq/web-shared/dist/components";
import React from "react";
import { ACADEMY_MEDIA } from "../../RentmatchAcademy.media";
import { EAcademyMedia, EAcademyMediaType } from "../../RentmatchAcademy.types";
import * as S from "./AcademyMedia.styles";

interface IAcademyMediaProps {
  mediaId: EAcademyMedia;
  // The section or slide title, so a screen reader says what the image shows,
  // and the heading of the enlarged view.
  alt: string;
}

export const AcademyMedia = ({ mediaId, alt }: IAcademyMediaProps) => {
  const media = ACADEMY_MEDIA[mediaId];

  // State
  const [isEnlarged, setIsEnlarged] = React.useState(false);

  // Event handlers
  const handleOpen = () => setIsEnlarged(true);

  const handleClose = () => setIsEnlarged(false);

  // Lifecycle
  React.useEffect(() => {
    if (!isEnlarged) {
      return;
    }

    // The shared Modal closes on its cross and on the backdrop only.
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        handleClose();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [isEnlarged]);

  // Render
  if (media.type === EAcademyMediaType.Video) {
    return (
      <S.Frame isPhone={media.isPhone}>
        <S.Video
          src={media.src}
          poster={media.poster}
          controls={true}
          muted={true}
          playsInline={true}
          preload="none"
          aria-label={alt}
        />
      </S.Frame>
    );
  }

  // Screenshots are detailed, so a click shows them large in a modal.
  return (
    <>
      <S.Frame isPhone={media.isPhone}>
        <S.ZoomButton type="button" onClick={handleOpen} aria-label={alt}>
          <S.Image src={media.src} alt={alt} loading="lazy" />
        </S.ZoomButton>
      </S.Frame>
      {isEnlarged && (
        <Modal width="extraLarge" heading={alt} onClose={handleClose}>
          <S.EnlargedImage src={media.src} alt={alt} isPhone={media.isPhone} />
        </Modal>
      )}
    </>
  );
};
